export const projects = [
  {
    title: "WSU Vancouver is...",
    subtitle: "JavaScript, HTML, CSS",
    description:
        "I carried the role of Web Development Team Lead in a campaign to increase community interest in pursuing higher education at Washington State University Vancouver for the Marketing and Communications Department.",
    image: "./wsu-vancouver-is.jpeg",
    link: "#projects",
  },
  {
    title: "Othello",
    subtitle: "SwiftUI",
    description:
        "Using SwiftUI and XCode I recreated the classic board game Othello for iOS.",
    image: "./othello-game.png",
    link: "https://github.com/ajfierst/Othello",
  },
  {
    title: "Hansel and Gretel: A Modern Retelling",
    subtitle: "HTML and CSS",
    description:
      "A narrative website created by using HTML and CSS. I wanted to take a classic Grimm Brother's fairy tale and reimagine it in a modern way.",
    image: "./project-hanselgretel.gif",
    link: "https://dtc-wsuv.org/afierst22/narrative/",
  },
  {
    title: "Weather App",
    subtitle: "HTML, CSS, and OpenWeatherMap API",
    description:
      "A weather application made with HTML and CSS using the OpenWeatherMap API. Demonstrating my ability to learn and apply an API in a practical way. ",
    image: "./project-weatherapp.gif",
    link: "https://dtc-wsuv.org/afierst22/weather/",
  },
  {
    title: "Logistic Regression Model",
    subtitle: "Python, Scikit-Learn, Pandas",
    description:
      "A logistic regression model that uses a dataset of League of Legends matches to learn how to predict if a game will be won based on a variety of features.",
    image: "./project-machinelearning.gif",
    link: "#projects",
  },
  {
    title: "Knight Runner",
    subtitle: "JavaScript and HTML Canvas",
    description:
      "An \"endless runner\" game made using Canvas and JavaScript. My first programming project that uses sprites and animations. Give it a try!",
    image: "./project-canvasgame.gif",
    link: "https://dtc-wsuv.org/afierst22/canvas-game/",
  },
];

export const biography = [
  {
    quote:
      "I was born and raised in Vancouver, WA. Prior to starting my journey at Washington State University, I served four years in the United States Army. Growing up I was always tinkering with anything and everything to learn about how things worked. It's a habit I don't think I'll ever outgrow, as today I find myself passionate about programming - determined to develop web applications and my knowledge in the field. ",
    image: "./profile.jpg",
    name: "Austin Fierst",
    company: "WSU Vancouver",
  },
];

export const skills = [
  "JavaScript",
  "TypeScript",
  "HTML5",
  "CSS3",
  "React",
  "Python 3",
  "C#",
  "C++",
];
